import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "ant-row ss-grade-personalizada-titulo",
  style: {"margin-top":"0"}
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-col ant-col-xs-2 ant-col-xl-1",
    style: {"text-align":"center"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, " ")
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-col ant-col-xs-22 ant-col-xl-9",
    style: {"text-align":"left"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Estrutura CIP")
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-col ant-col-xs-24 ant-col-xl-6",
    style: {"text-align":"right"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Valor Total CIP Unidade")
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-col ant-col-xs-24 ant-col-xl-8",
    style: {"text-align":"center","padding-left":"12px"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Data Processamento")
  ])
], -1)
const _hoisted_3 = { class: "ant-row ss-grade-personalizada-linha" }
const _hoisted_4 = {
  class: "ant-col ant-col-xs-2 ant-col-xl-1",
  style: {"text-align":"center"}
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  class: "ant-col ant-col-xs-22 ant-col-xl-9",
  style: {"text-align":"left"}
}
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-6",
  style: {"text-align":"right"}
}
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-8",
  style: {"text-align":"center","padding-left":"12px"}
}
const _hoisted_11 = ["value"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "ant-row ss-grade-personalizada-titulo",
  style: {"margin-top":"8px"}
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-col ant-col-xs-24 ant-col-xl-14",
    style: {"text-align":"left"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Categoria Financeira")
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-col ant-col-xs-24 ant-col-xl-10",
    style: {"text-align":"right"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Valor Calculado")
  ])
], -1)
const _hoisted_13 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-14",
  style: {"text-align":"left"}
}
const _hoisted_14 = ["value"]
const _hoisted_15 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-10",
  style: {"text-align":"right"}
}
const _hoisted_16 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_card, null, {
      default: _withCtx(() => [
        (!_ctx.UtilitarioGeral.validaLista(_ctx.props.cips))
          ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
              key: 0,
              mensagem: "Nenhuma estrutura CIP vinculada para esta OP."
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.cips, (cip, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `${cip.codigo}-${cip.codigoCipEstrutura}-${index}`,
                  class: "ss-padding-separacao-esquerda",
                  style: {"margin-bottom":"12px"}
                }, [
                  _hoisted_2,
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "ant-btn ant-btn-link",
                        style: {"padding":"0","min-width":"20px","border":"none","box-shadow":"none","font-size":"22px","font-weight":"600","line-height":"1"},
                        onClick: ($event: any) => (_ctx.alternarExpansao(_ctx.obterChaveCip(cip, index)))
                      }, _toDisplayString(_ctx.estaExpandido(_ctx.obterChaveCip(cip, index)) ? '-' : '+'), 9, _hoisted_5)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("input", {
                        class: "ant-input",
                        type: "text",
                        value: _ctx.obterNomeEstrutura(cip),
                        disabled: "true"
                      }, null, 8, _hoisted_7)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("input", {
                        class: "ant-input",
                        type: "text",
                        value: _ctx.formatarMoeda(cip.valorTotalCipUnidade),
                        disabled: "true",
                        style: {"text-align":"right"}
                      }, null, 8, _hoisted_9)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("input", {
                        class: "ant-input",
                        type: "text",
                        value: _ctx.formatarData(cip.dataProcessamento),
                        disabled: "true",
                        style: {"max-width":"180px","margin":"0 auto"}
                      }, null, 8, _hoisted_11)
                    ])
                  ]),
                  (_ctx.estaExpandido(_ctx.obterChaveCip(cip, index)))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_12,
                        (!_ctx.UtilitarioGeral.validaLista(cip.categorias))
                          ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                              key: 0,
                              mensagem: "Nenhuma categoria financeira retornada para esta estrutura."
                            }))
                          : (_openBlock(), _createBlock(_component_a_form, {
                              key: 1,
                              name: "ss-form-op-cip-categorias",
                              class: "ss-altura-rolagem-padrao ss-desabilitar-rolagem-horizontal"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cip.categorias, (categoria, categoriaIndex) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "ant-row ss-grade-personalizada-linha",
                                    key: `${categoria.codigo}-${categoria.codigoPlanoContaCategoria}-${categoriaIndex}`
                                  }, [
                                    _createElementVNode("div", _hoisted_13, [
                                      _createElementVNode("input", {
                                        class: "ant-input",
                                        type: "text",
                                        value: _ctx.obterNomeCategoria(categoria),
                                        disabled: "true"
                                      }, null, 8, _hoisted_14)
                                    ]),
                                    _createElementVNode("div", _hoisted_15, [
                                      _createElementVNode("input", {
                                        class: "ant-input",
                                        type: "text",
                                        value: _ctx.formatarMoeda(categoria.valorCalculado),
                                        disabled: "true",
                                        style: {"text-align":"right"}
                                      }, null, 8, _hoisted_16)
                                    ])
                                  ]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1024))
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
      ]),
      _: 1
    })
  ]))
}